import React from 'react';
import AutocompleteInput from './AutoCompleteInput';
import './IngredientForm.css';

const IngredientForm = ({ ingredientsData, onUpdate }) => {
  const [inputs, setInputs] = React.useState([{ name: '', grams: '' }]);

  const handleChange = (index, field, value) => {
    const updated = [...inputs];
    updated[index][field] = field === 'grams' ? parseFloat(value) : value;
    setInputs(updated);
    onUpdate(updated);
  };

  const addIngredient = () => {
    if (inputs.length < 5) {
      setInputs([...inputs, { name: '', grams: '' }]);
    }
  };

  const removeIngredient = (index) => {
    const updated = inputs.filter((_, i) => i !== index);
    setInputs(updated);
    onUpdate(updated);
  };

  return (
    <div className="form-container">
    {inputs.map((input, i) => (
  <div key={i} className="input-row">
    <div className="row-top">
      <div className="sl-no">{i + 1}.</div>
      <AutocompleteInput
        ingredients={ingredientsData}
        value={input.name}
        onChange={(val) => handleChange(i, 'name', val)}
      />
    </div>
    <div className="row-bottom">
      <input
        type="number"
        placeholder="Grams"
        value={input.grams}
        onChange={(e) => handleChange(i, 'grams', e.target.value)}
      />
     
      <button
        className="delete-btn"
        onClick={() => removeIngredient(i)}
        aria-label={`Remove ingredient ${i + 1}`}
      >
        Remove
      </button>
    </div>
  </div>
))}


      <button onClick={addIngredient} disabled={inputs.length >= 5}>
        + Add Ingredient
      </button>
      {inputs.length >= 5 && (
        <p className="note">You’ve already added 5 ingredients.</p>
      )}
    </div>
  );
};

export default IngredientForm;
